import { Trans } from 'react-i18next'
import React, { useEffect } from 'react'
import Flex from 'typescript-styled-flex'
import { isSubmitting } from 'redux-form'
import { connect, useSelector } from 'react-redux'
import {
  ModalFlex,
  ModalHeader,
  ModalHeaderLabel,
} from '../../../components/Template/Modal'
import { ServicesModalWrapper } from '../../../components/Calendar/ReservationModal'
import { IEvent } from '../../../models/Event'
import { IStore } from '../../../reducers'
import { ICreateReservationFormValues } from '../../Form/CreateReservation/CreateReservation'
import Icon from '../../../components/Template/Modal/CloseButton/Icon'
import useSize from '../../../hooks/useSize'
import TransferReservationForm from './TransferReservationForm'
import { Mixpanel } from '../../../utils/Mixpanel'
import { getUserId } from '../../../reducers/userAccount/selectors/userAccount'

function TransferModal({
  close,
  eventData,
  eventId,
  isLoading,
  open,
  modalId,
  onTransferSuccess,
}: ITransferModalProps & ITransferModalState) {
  const size = useSize()
  const userId = useSelector(getUserId)

  useEffect(() => {
    Mixpanel.track('Reservation Move Screen View', {
      'Reservation ID': Number(eventId),
    })
  }, [eventId])

  const handleClose = () => {
    if (close) {
      close(modalId)
    }
  }

  const handleFormSuccess = () => {
    if (onTransferSuccess) {
      onTransferSuccess()
    }
    Mixpanel.track('Reservation Move Completed', {
      'Reservation ID': Number(eventId),
    })
    Mixpanel.people.increment(userId, 'Reservations Moved', 1)
    handleClose()
  }

  return (
    <ModalFlex
      open={open}
      onClose={handleClose}
      disableBackdropClick={isLoading}
      style={{ alignItems: 'start' }}
    >
      <ServicesModalWrapper
        style={{
          marginTop: '80px',
          maxHeight: '90vh',
          maxWidth: '484px',
          padding: '1em',
        }}
      >
        <ModalHeader style={{ paddingBottom: '0' }}>
          {/* eslint-disable-next-line react/jsx-no-undef */}
          <Flex row={true} style={{ whiteSpace: 'nowrap', width: '100%' }}>
            <ModalHeaderLabel
              style={{
                fontSize: `${16 * size}px`,
                padding: `${5 * size}px 0px`,
                whiteSpace: 'pre-wrap',
                width: '100%',
              }}
            >
              <Trans i18nKey={'reservation_move_title'} />
            </ModalHeaderLabel>
          </Flex>

          <Flex style={{ width: '20%' }} justifyEnd={true} alignCenter={true}>
            <Icon
              style={{ marginRight: `${-4 * size}px` }}
              onClick={handleClose}
            />
          </Flex>
        </ModalHeader>
        <TransferReservationForm
          eventId={eventId}
          eventData={eventData}
          onSuccess={handleFormSuccess}
        />
      </ServicesModalWrapper>
    </ModalFlex>
  )
}

const mapStateToProps = (state: IStore): ITransferModalState => ({
  isLoading: isSubmitting('copyForm')(state),
})

export default connect(mapStateToProps)(TransferModal)

export interface ITransferModalProps {
  open?: boolean
  eventData: ICreateReservationFormValues
  eventId: IEvent['id'] | null
  close?: (modalId) => void
  onTransferSuccess?: () => void
  modalId?: string
}

export interface ITransferModalState {
  isLoading?: boolean
}
